export default __webpack_public_path__ + "static/media/cameraPcv1.0.370301b2.png";